import React from 'react'
import AccountCircle from '@material-ui/icons/AccountCircle'

export default function AccountCircleIcon() {

    return (
        <AccountCircle />
    )
}